import { router } from '@inertiajs/react'
import AppLayout from '@/components/layouts/AppLayout'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import StorefrontIcon from '@mui/icons-material/Storefront'
import CategoryIcon from '@mui/icons-material/Category'
import SecurityIcon from '@mui/icons-material/Security'

export default function Home() {
  return (
    <AppLayout>
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight={700}>
          Self-Hostable Applications
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 4, maxWidth: 600, mx: 'auto' }}>
          Discover, deploy, and manage applications for your infrastructure.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => router.visit('/apps')}
          sx={{ mb: 6 }}
        >
          Browse Apps
        </Button>

        <Grid container spacing={4} justifyContent="center">
          <Grid size={{ xs: 12, md: 4 }}>
            <Card elevation={1} sx={{ height: '100%' }}>
              <CardActionArea onClick={() => router.visit('/apps')}>
                <CardContent sx={{ textAlign: 'center', py: 4 }}>
                  <StorefrontIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h6" gutterBottom>Browse Apps</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Explore a curated collection of self-hostable applications.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card elevation={1} sx={{ height: '100%' }}>
              <CardActionArea onClick={() => router.visit('/apps')}>
                <CardContent sx={{ textAlign: 'center', py: 4 }}>
                  <CategoryIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h6" gutterBottom>Categories</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Find apps by category — databases, monitoring, and more.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card elevation={1} sx={{ height: '100%' }}>
              <CardActionArea onClick={() => router.visit('/apps')}>
                <CardContent sx={{ textAlign: 'center', py: 4 }}>
                  <SecurityIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h6" gutterBottom>Deploy Securely</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Generate deployment configurations for your infrastructure.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </AppLayout>
  )
}
